const { VITE_API_URL, VITE_APP_ENV, VITE_SENTRY_DNS } = import.meta.env;
const ID_GROUP_DWELL_LEGIMETRIE = import.meta.env.VITE_ID_DEFAULT_GROUP;

export const TOGGLE_LOGIN = "TOGGLE_LOGIN";
export const TOGGLE_LOGIN_SUCCESS = "TOGGLE_LOGIN_SUCCESS";
export const TOGGLE_LOGIN_FAILED = "TOGGLE_LOGIN_FAILED";

export const TOGGLE_REGISTER = "TOGGLE_SIGNUP";
export const TOGGLE_REGISTER_SUCCESS = "TOGGLE_SIGNUP_SUCCESS";
export const TOGGLE_REGISTER_FAILED = "TOGGLE_SIGNUP_FAILED";

export const TOGGLE_LOGOUT = "TOGGLE_LOGOUT";
export const TOGGLE_LOGOUT_SUCCESS = "TOGGLE_LOGOUT_SUCCESS";
export const TOGGLE_LOGOUT_FAILED = "TOGGLE_LOGOUT_FAILED";

export const GET_COMPANY_INFOS = "GET_COMPANY_INFOS";
export const GET_COMPANY_INFOS_SUCCESS = "GET_COMPANY_INFOS_SUCCESS";
export const GET_COMPANY_INFOS_FAILED = "GET_COMPANY_INFOS_FAILED";

export const TOGGLE_EMAIL_EXISTS = "TOGGLE_EMAIL_EXISTS";
export const TOGGLE_EMAIL_EXISTS_SUCCESS = "TOGGLE_EMAIL_EXISTS_SUCCESS";
export const TOGGLE_EMAIL_EXISTS_FAILED = "TOGGLE_EMAIL_EXISTS_FAILED";

export const TOGGLE_COMPANY_EXISTS = "TOGGLE_COMPANY_EXISTS";
export const TOGGLE_COMPANY_EXISTS_SUCCESS = "TOGGLE_COMPANY_EXISTS_SUCCESS";
export const TOGGLE_COMPANY_EXISTS_FAILED = "TOGGLE_COMPANY_EXISTS_FAILED";

export const TOGGLE_CREATE_COMPANY = "TOGGLE_CREATE_COMPANY";
export const TOGGLE_CREATE_COMPANY_SUCCESS = "TOGGLE_CREATE_COMPANY_SUCCESS";
export const TOGGLE_CREATE_COMPANY_FAILED = "TOGGLE_CREATE_COMPANY_FAILED";

export const VERIFY_PHONE_NUMBER = "VERIFY_PHONE_NUMBER";
export const VERIFY_PHONE_NUMBER_SUCCESS = "VERIFY_PHONE_NUMBER_SUCCESS";
export const VERIFY_PHONE_NUMBER_FAILED = "VERIFY_PHONE_NUMBER_FAILED";

export const VERIFY_IF_SUB_DOMAIN_EXIST = "VERIFY_IF_SUB_DOMAIN_EXIST";
export const GET_USER = "GET_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";

export const SET_IS_LOGGED = "SET_IS_LOGGED";
export const SET_IS_LOGGED_TRUE = "SET_IS_LOGGED_TRUE";
export const SET_IS_LOGGED_FALSE = "SET_IS_LOGGED_FALSE";

export const TOKEN_IS_VALID = "TOKEN_IS_VALID";
export const TOKEN_IS_VALID_FAILED = "TOKEN_IS_VALID_FAILED";

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILED = "FORGOT_PASSWORD_FAILED";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";

export const API_URL = VITE_API_URL;
export const APP_ENV = VITE_APP_ENV;

export const SENTRY_DNS = VITE_SENTRY_DNS;

export const ID_DEFAULT_GROUP = ID_GROUP_DWELL_LEGIMETRIE;
